import { render, staticRenderFns } from "./tags-input-v2.vue?vue&type=template&id=3cbf936f&scoped=true"
import script from "./tags-input-v2.vue?vue&type=script&lang=js"
export * from "./tags-input-v2.vue?vue&type=script&lang=js"
import style0 from "./tags-input-v2.vue?vue&type=style&index=0&id=3cbf936f&prod&lang=css"
import style1 from "./tags-input-v2.vue?vue&type=style&index=1&id=3cbf936f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf936f",
  null
  
)

export default component.exports